export const buildNumber = '20260521.1';
export const version = 'main';
export const latestCommit = 'cb6a391e85cddeacf58ac6fe902449788e607915';
